import { LAST_PRE_DELIVERED_ITEM } from 'actions/user'

export default (state = null, action) => {
  switch (action.type) {
    case LAST_PRE_DELIVERED_ITEM:
      if (action.error) {
        return false
      } else {
        return action.payload.data;
      }
  }

  return state;
}
